import React, { useContext, useState, useEffect } from "react";
import { Flex, Heading, Text, Checkbox, MRadio, MTag } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../../contexts/i18nContext";
import "./events-tab.scss";

function EventsTab(props) {
  const { app, setApp, events } = props;
  const i18n = useContext(I18nContext);
  const simulationEventVeticals = [
    { name: "Retail", value: "Simulation-Retail" },
    { name: "Workspace", value: "Simulation-Workspaces" }
  ];
  const eventLocations = [
    { name: "Root Level", type: "root" },
    { name: "Groups", type: "group" },
    { name: "Network", type: "network" },
    { name: "Floor", type: "floor" },
    { name: "Zone", type: "zone" }
  ];
  const eventLocationTypes = eventLocations.map((evt) => evt.type);

  const [eventStr, setEventStr] = useState("");
  const [locationTypesStr] = useState("");
  const [iotTelemetryPermission, setIotTelemetryPermissionString] = useState("");
  const [iotUserActionPermission, setIotUserActionPermissionString] = useState("");
  const locationTypeNameMapping = {
    root: "Root Level",
    group: "Groups",
    network: "Network",
    floor: "Floor",
    zone: "Zone"
  };

  const prepareEventStr = () => {
    if (app?.subscriptions.length) {
      if (app?.subscriptions[0].eventTypes && app?.subscriptions[0].eventTypes.length) {
        let eventsString = "";
        let telemetryPermission = "";
        let userActionPermission = "";
        const permittedEvents = app?.subscriptions[0].eventTypes;
        console.log(permittedEvents);
        const evts = [...permittedEvents];
        if (evts && evts.length) {
          evts.forEach((evt) => {
            if (evt) {
              switch (evt) {
                // case "DEVICE_ENTRY": eventsString += ", device entry"; break;
                // case "DEVICE_EXIT": eventsString += ", device exit"; break;
                case "PROFILE_UPDATE":
                  eventsString += ", profile update";
                  break;
                case "LOCATION_CHANGE":
                  eventsString += ", location information change";
                  break;
                // case "TP_PEOPLE_COUNT_UPDATE": eventsString += ", tele presence count update"; break;
                case "DEVICE_LOCATION_UPDATE":
                  eventsString += ", device location update";
                  break;
                case "DEVICE_ACTIVE":
                  eventsString += ", device active";
                  break;
                case "DEVICE_PASSIVE":
                  eventsString += ", device passive";
                  break;
                default:
                  break;
              }

              if (evt === "IOT_TELEMETRY") {
                telemetryPermission = i18n.t("partner-dashboard-app.partner-apps.app-settings.passive-ble-telemetry-text");
              }
              if (evt === "IOT_USER_ACTION") {
                userActionPermission = i18n.t("partner-dashboard-app.partner-apps.app-settings.active-ble-telemetry-text");
              }
            }
          });
          if (eventsString.length) {
            const commaEvtIndex = eventsString.indexOf(",");
            if (commaEvtIndex > -1) {
              eventsString = eventsString.substring(commaEvtIndex + 1, eventsString.length);
            }
          }
        }
        setEventStr(eventsString);
        setIotTelemetryPermissionString(telemetryPermission);
        setIotUserActionPermissionString(userActionPermission);
      } else {
        setEventStr("");
      }
    } else {
      setEventStr("");
    }
  };

  useEffect(() => {
    if (app && app.subscriptions && app.subscriptions[0].enableClientMAC) {
      // do nothing
    } else {
      const newEditingNode = { ...app };
      newEditingNode.subscriptions[0].enableClientMAC = false;
      setApp(newEditingNode);
    }

    if (app && app.subscriptions && app.subscriptions[0].enableSocial) {
      // do nothing
    } else {
      const newEditingNode = { ...app };
      newEditingNode.subscriptions[0].enableSocial = false;
      setApp(newEditingNode);
    }
    prepareEventStr();
  }, []);

  const eventTemplate = (ev, index) => {
    return (
      <Text size="p3" key={`evdsc-${index}`} weight="regular" color="light">
        {ev.description}
      </Text>
    );
  };

  const isEventSelected = (evt) => {
    let found = false;
    if (app.subscriptions[0] && app.subscriptions[0].eventTypes.length) {
      for (let j = 0, maxPoint = app.subscriptions[0].eventTypes.length; j < maxPoint; j++) {
        if (app.subscriptions[0].eventTypes[j] == evt.key) {
          found = true;
        }
      }
    }
    return found;
  };

  const isGeoEventSelected = () => {
    return app.subscriptions[0].enableGeoCoordinates;
  };

  const onClickEvent = (evt) => {
    if (isEventSelected(evt)) {
      // remove event
      const newEditingNode = { ...app };
      const evtKeyIndex = newEditingNode.subscriptions[0].eventTypes.indexOf(evt.key);
      if (evtKeyIndex > -1) {
        newEditingNode.subscriptions[0].eventTypes.splice(evtKeyIndex, 1);
      }
      setApp(newEditingNode);
      setTimeout(() => {
        prepareEventStr();
      }, 500);
    } else {
      // push event
      const newEditingNode = { ...app };
      if (newEditingNode.subscriptions[0] && newEditingNode.subscriptions[0].eventTypes) {
        newEditingNode.subscriptions[0].eventTypes.push(evt.key);
      } else {
        newEditingNode.subscriptions[0].eventTypes = [];
        newEditingNode.subscriptions[0].eventTypes.push(evt.key);
      }
      setApp(newEditingNode);
      setTimeout(() => {
        prepareEventStr();
      }, 500);
    }
  };

  const onClickGeoEvent = () => {
    const newEditingNode = { ...app };
    newEditingNode.subscriptions[0].enableGeoCoordinates = !newEditingNode.subscriptions[0].enableGeoCoordinates;
    setApp(newEditingNode);
  };

  const onChangeLocationType = (evt) => {
    const newEditingNode = { ...app };
    if (newEditingNode.subscriptions[0] && newEditingNode.subscriptions[0].location) {
      newEditingNode.subscriptions[0].location.selection = evt.target.value;
      newEditingNode.subscriptions[0].location.types = [...eventLocationTypes];
    } else {
      newEditingNode.subscriptions[0].location = {};
      newEditingNode.subscriptions[0].location.selection = evt.target.value;
      newEditingNode.subscriptions[0].location.types = [...eventLocationTypes];
    }
    setApp(newEditingNode);
  };

  const onChangeMacAddress = (evt) => {
    const newEditingNode = { ...app };
    newEditingNode.subscriptions[0].enableClientMAC = JSON.parse(evt.target.value);
    setApp(newEditingNode);
  };

  const onChangeSocial = (evt) => {
    const newEditingNode = { ...app };
    newEditingNode.subscriptions[0].enableSocial = JSON.parse(evt.target.value);
    setApp(newEditingNode);
  };

  const onChangeSimulationType = (evt) => {
    const newEditingNode = { ...app };
    newEditingNode.disableSimulation = evt.target.value ? JSON.parse(evt.target.value) : evt.target.value;
    setApp(newEditingNode);
  };

  const checkboxTemplate = (ev, index) => {
    const template =
      ev && !ev.deprecated ? (
        <div key={index}>
          <Checkbox className="boldFont" key={index} onClick={() => onClickEvent(ev)} checked={isEventSelected(ev)}>
            {ev.name}
          </Checkbox>
          <div className="evtDesc">{eventTemplate(ev, index)}</div>
          {ev.license && ev.license === "ACT" ? (
            <div className="evtDesc">
              <MTag.Status size="md" status="warning">
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.event-license-act-only")}
              </MTag.Status>
            </div>
          ) : (
            ""
          )}
          {ev.key === "DEVICE_LOCATION_UPDATE" && isEventSelected(ev) ? (
            <div style={{ "margin-top": "10px" }} className="evtDesc" key={`${index}-1`}>
              <Checkbox className="boldFont" key={index} onClick={() => onClickGeoEvent()} checked={isGeoEventSelected()}>
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.receive-geo-co-ordinates-text")}
              </Checkbox>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      );
    return template;
  };

  const onClickSimulationEvent = (evt) => {
    const newEditingNode = { ...app };
    if (newEditingNode.simulationVerticals) {
      const evtIndex = newEditingNode.simulationVerticals.indexOf(evt.value);
      if (evtIndex > -1) {
        newEditingNode.simulationVerticals.splice(evtIndex, 1);
      } else {
        newEditingNode.simulationVerticals.push(evt.value);
      }
    } else {
      newEditingNode.simulationVerticals = [];
      newEditingNode.simulationVerticals.push(evt.value);
    }
    setApp(newEditingNode);
  };

  const isSimulationEventSelected = (evt) => {
    let found = false;
    if (app.simulationVerticals && app.simulationVerticals.length) {
      for (let j = 0, maxPoint = app.simulationVerticals.length; j < maxPoint; j++) {
        if (app.simulationVerticals[j] == evt.value) {
          found = true;
        }
      }
    }
    return found;
  };

  const simulationVerticalCheckboxTemplate = (evt, index) => {
    return (
      <Checkbox className="boldFont" key={index} onClick={() => onClickSimulationEvent(evt)} checked={isSimulationEventSelected(evt)}>
        {evt.name}
      </Checkbox>
    );
  };

  const simulationVerticalsTemplate = () => {
    return (
      <Flex direction="vertical" gap={8}>
        <Flex wrap gap={8}>
          {simulationEventVeticals.map((evt, index) => simulationVerticalCheckboxTemplate(evt, index))}
        </Flex>
      </Flex>
    );
  };

  const updateEventLocationType = (type) => {
    const newEditingNode = { ...app };
    if (newEditingNode.subscriptions[0] && newEditingNode.subscriptions[0].location && newEditingNode.subscriptions[0].location.selection) {
      const evtIndex = newEditingNode.subscriptions[0].location.types.indexOf(type);
      if (evtIndex > -1) {
        newEditingNode.subscriptions[0].location.types.splice(evtIndex, 1);
      } else {
        newEditingNode.subscriptions[0].location.types.push(type);
      }
    }
    setApp(newEditingNode);
  };

  const isEventLocationTypeChecked = (type) => {
    let found = false;
    if (app.subscriptions[0] && app.subscriptions[0].location && app.subscriptions[0].location.types) {
      for (let j = 0, maxPoint = app.subscriptions[0].location.types.length; j < maxPoint; j++) {
        if (app.subscriptions[0].location.types[j] == type) {
          found = true;
          break;
        }
      }
    }
    return found;
  };

  const getLocationTypeNameTemplate = () => {
    let locationNameStr = "";
    if (app?.subscriptions && app?.subscriptions.length && app?.subscriptions[0]?.location?.types && app?.subscriptions[0]?.location?.types.length) {
      app.subscriptions[0].location.types.forEach((type) => {
        if (locationTypeNameMapping[type]) {
          locationNameStr += `, ${locationTypeNameMapping[type]}`;
        }
      });
      if (locationNameStr.length) {
        const commaEvtIndex = locationNameStr.indexOf(",");
        if (commaEvtIndex > -1) {
          locationNameStr = locationNameStr.substring(commaEvtIndex + 1, locationNameStr.length);
        }
      }
    }
    if (locationNameStr.length) {
      const locStrArr = locationNameStr.split(",");
      return (
        <ul style={{ fontSize: 14 }}>
          {locStrArr.map((loc) => (
            <li key={loc}>{loc}</li>
          ))}
        </ul>
      );
    }
    return "";
  };

  return (
    <div className="pBottom40">
      <div>
        <div className="leftLayout bRightGrey">
          <Flex direction="vertical" gap={16}>
            <Flex direction="vertical" gap={8}>
              <Heading size="section">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.event-types-text")}</Heading>
            </Flex>
            <Flex wrap className="formMaxWidth2" direction="vertical" gap={24}>
              {events && events.map((evt, index) => checkboxTemplate(evt, index))}
            </Flex>
            <Flex direction="vertical" gap={8} />
            <Flex direction="vertical" gap={8}>
              <Heading>Event Settings</Heading>
              <Flex direction="vertical" gap={8}>
                <div className="event-subheading">{i18n.t("partner-dashboard-app.partner-apps.partner-app-activation.choose-locations-text")}</div>
                <div className="event-subheading2">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.send-events-triggered-text")}</div>
              </Flex>
              <Flex direction="vertical" gap={8}>
                <MRadio
                  direction="horizontal"
                  onChange={onChangeLocationType}
                  value={app?.subscriptions[0]?.location?.selection}
                  options={[
                    {
                      key: 1,
                      label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.all-location-types"),
                      value: "all"
                    },
                    {
                      key: 2,
                      label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.location-types-text"),
                      value: "specific"
                    }
                  ]}
                  size="md"
                />
                {app?.subscriptions[0]?.location?.selection === "specific" ? (
                  <Flex direction="vertical" gap={4}>
                    {eventLocations.map((evt) => (
                      <Checkbox
                        className="boldFont"
                        key={evt.type}
                        onClick={() => {
                          updateEventLocationType(evt.type);
                        }}
                        checked={isEventLocationTypeChecked(evt.type)}
                      >
                        {evt.name}
                      </Checkbox>
                    ))}
                  </Flex>
                ) : (
                  ""
                )}
              </Flex>
              <Flex direction="vertical" gap={4} />
              <Flex direction="vertical" gap={8}>
                <div className="event-subheading">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.mac-address-sharing-text")}</div>
                <div className="event-subheading2">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.receive-client-mac-address-text")}</div>
              </Flex>
              <Flex direction="vertical" gap={8}>
                <MRadio
                  direction="horizontal"
                  onChange={onChangeMacAddress}
                  value={app?.subscriptions[0]?.enableClientMAC}
                  options={[
                    {
                      key: 1,
                      label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.no-text"),
                      value: false
                    },
                    {
                      key: 2,
                      label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.yes-text"),
                      value: true
                    }
                  ]}
                  size="md"
                />
              </Flex>
              <Flex direction="vertical" gap={4} />
              <Flex direction="vertical" gap={8}>
                <div className="event-subheading">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.social-identifier-sharing-text")}</div>
              </Flex>
              <Flex direction="vertical" gap={8}>
                <MRadio
                  direction="horizontal"
                  onChange={onChangeSocial}
                  value={app?.subscriptions[0]?.enableSocial}
                  options={[
                    {
                      key: 1,
                      label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.no-text"),
                      value: false
                    },
                    {
                      key: 2,
                      label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.yes-text"),
                      value: true
                    }
                  ]}
                  size="md"
                />
              </Flex>
              {app.region === "us" && (
                <>
                  <Flex direction="vertical" gap={4} />
                  <Flex direction="vertical" gap={8}>
                    <div className="event-subheading">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.receive-simulation-events-text")}</div>
                    <div className="event-subheading2">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.receive-social-identifier-text")}</div>
                  </Flex>
                  <Flex direction="vertical" gap={8}>
                    <MRadio
                      direction="horizontal"
                      onChange={onChangeSimulationType}
                      value={app?.disableSimulation}
                      options={[
                        {
                          key: 1,
                          label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.no-text"),
                          value: true
                        },
                        {
                          key: 2,
                          label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.yes-text"),
                          value: false
                        }
                      ]}
                      size="md"
                    />
                    {!app?.disableSimulation && simulationVerticalsTemplate()}
                  </Flex>
                </>
              )}
            </Flex>
          </Flex>
        </div>
        <div className="rightLayout">
          <Flex className="pLeft30" direction="vertical" gap={8} style={{ paddingTop: 30, paddingBottom: 30, backgroundColor: "#fafafa" }}>
            <Heading size="section">{i18n.t("partner-dashboard-app.partner-apps.app-settings.app-requires-additional-permissions-text")}</Heading>
            <Text size="p3" weight="regular">
              {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.permission-customer-ask-text")}
            </Text>
            <Text style={{ "margin-top": "10px" }} size="p4" weight="regular">
              {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.app-requires-zone-level-text")}
            </Text>
            {eventStr.length ? (
              <Text size="p4" weight="regular">
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.includes-events-text")}
                {`${eventStr} `}
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.devices-connected-to-your-network-text")}
              </Text>
            ) : (
              ""
            )}
            {locationTypesStr.length ? (
              <Text size="p4" weight="regular">
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.events-generated-every-time-text")}
                {locationTypesStr}
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.location-text")}.
              </Text>
            ) : (
              <Text size="p4" weight="regular">
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.events-generated-every-time-static-text")}
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.info-available-in-spaces-text")}
              </Text>
            )}
            {iotTelemetryPermission.length ? (
              <Text size="p4" weight="regular">
                {iotTelemetryPermission}
              </Text>
            ) : (
              ""
            )}
            {iotUserActionPermission.length ? (
              <Text size="p4" weight="regular">
                {iotUserActionPermission}
              </Text>
            ) : (
              ""
            )}
          </Flex>
          <Flex className="pLeft30" direction="vertical" gap={8} style={{ paddingTop: 30, borderTop: "1px solid #dddfe2" }}>
            <Heading size="section">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.location-permissions-text")}</Heading>
            <Text size="p3" weight="regular">
              {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.customer-asked-to-allow-permissions-text")}
            </Text>
            <Text size="p4" weight="regular" style={{ marginTop: 10 }}>
              {getLocationTypeNameTemplate()}
            </Text>
          </Flex>
          {app?.subscriptions[0]?.enableClientMAC ? (
            <Flex className="pLeft30" direction="vertical" gap={8} style={{ paddingTop: 30 }}>
              <Heading size="section">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.mac-address-permission-text")}</Heading>
              <Text size="p3" weight="regular">
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.customer-asked-to-allow-permission-text")}
              </Text>
            </Flex>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

export default EventsTab;
